import { render } from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=template&id=b7f6245a&scoped=true"
import script from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=script&lang=js"
export * from "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=script&lang=js"

import "./VideoPlayerControlsSettingsAudioTrack.vue?vue&type=style&index=0&id=b7f6245a&scoped=true&lang=css"

import exportComponent from "/Users/sxdube/Documents/code/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f6245a"]])

export default __exports__